import axios from 'axios';
import { attachJwtInterceptor } from 'utils/jwtInterceptor';

/**
 * Public API connection
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const API_ASTOR = axios.create({
    baseURL: process.env.REACT_APP_API_ASTOR
});

export const API_SERVICE_AKADEMIK = axios.create({
    baseURL: process.env.REACT_APP_API_SERVICE_AKADEMIK
});

export const API_MHS_KRS = axios.create({
    baseURL: process.env.REACT_APP_API_MHS_KRS
});

// Pasang JWT Bearer Interceptor otomatis
attachJwtInterceptor(API_ASTOR);
attachJwtInterceptor(API_SERVICE_AKADEMIK);
attachJwtInterceptor(API_MHS_KRS);
